<template>
    <div class="technicalservice">
        <!-- <img
            src="@/assets/images/ProHome/servicebanner.png"
            class="technicalservice-img"
        /> -->
        <div class="technicalservice_headbox">
            <div class="technicalservice_headleft">
                <img
                    src="../../assets/images/ProHome/consultleft.png"
                    alt="采购咨询服务banner1"
                />
            </div>
            <div class="technicalservice_headcenter">
                <div class="center_top">采购咨询服务</div>
                <div class="center_bottom">
                    您的需求我们有问必答，询价、询交期我们提供专业的服务为您一站式解决
                </div>
            </div>
            <div class="technicalservice_headright">
                <img
                    src="../../assets/images/ProHome/consultright.png"
                    alt="采购咨询服务banner2"
                />
            </div>
        </div>
        <div class="technicalservice-title">{{ typeName }}</div>
        <div class="title_tap" style="text-align: center;">请完整准确填写您的需求，我们将尽快回复您</div>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            label-width="auto"
            label-position="left"
            class="technicalservice-form"
        >
            <div class="technicalservice-content technicalservice-content-2">
                <div class="goods-box">
                    <div class="goods-item">
                        <p>商品编号：{{ detailsData.sn }}</p>
                    </div>
                    <div class="goods-item" style="justify-content: center;">
                        <p>商品名称：{{ detailsData.pn }}</p>
                    </div>
                    <div class="goods-item" style="justify-content: flex-end; padding-right: 30px;" v-if="detailsData.brandVO">
                        <p>品牌：{{ detailsData.brandVO.name }}</p>
                    </div>
                </div>
                <div class="display-flex" v-if="detailsData.sn">
                    <el-form-item prop="requireQuantity" label="需求数量（个）">
                        <el-input
                            placeholder="请填写需求数量"
                            v-model.trim="ruleForm.requireQuantity"
                            class="w-370 w-370-2"
                            clearable
                            maxlength="9"
                            @input="requireQuantityChange"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        prop="requireTimeRange"
                        label="需求时间"
                        class="date-item"
                    >
                        <el-select
                            v-model="ruleForm.requireTimeRange"
                            placeholder="请选择"
                            size="large"
                            class="select"
                        >
                            <el-option label="无要求" value="NO_REQUIRE" class="hdsitem"/>
                            <el-option
                                label="一周以内"
                                value="ONE_WEEK_WITHIN"
                                class="hdsitem"
                            />
                            <el-option
                                label="两周以内"
                                value="TWO_WEEK_WITHIN"
                                class="hdsitem"
                            />
                            <el-option
                                label="一个月以内"
                                value="ONE_MONTH_WITHIN"
                                class="hdsitem"
                            />
                            <el-option label="其他" value="OTHER" class="hdsitem" />
                        </el-select>
                        <el-input
                            placeholder="请输入交期：如60工作日"
                            v-if="ruleForm.requireTimeRange === 'OTHER'"
                            v-model="ruleForm.otherTime" v-trim
                            class="w-370 w-370-3"
                            clearable
                            maxlength="11"
                        >
                        </el-input>
                    </el-form-item>
                </div>
                <div class="display-flex" v-if="detailsData.sn">
                    <el-form-item prop="contacts" label="联系人">
                        <el-input
                            placeholder="请填写联系人"
                            v-model="ruleForm.contacts" v-trim
                            class="contactsgp"
                            clearable
                            maxlength="20"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="subjectType" label="主体类型" class="subjectType">
                        <el-radio-group v-model="ruleForm.subjectType">
                            <el-radio label="0" size="large">个人</el-radio>
                            <el-radio label="1" size="large">公司</el-radio>
                        </el-radio-group>
                        <el-input
                            style="width: 343px; margin-left: 10px; height: 40px;"
                            v-show="ruleForm.subjectType == '1'"
                            placeholder="请输入公司全称"
                            v-model="ruleForm.companyName" v-trim
                            clearable
                            maxlength="20"
                        >
                        </el-input>
                    </el-form-item>
                </div>
                <div class="title_tap">备注</div>
                <el-form-item prop="remark" label="" class="describes_item">
                    <el-input
                        v-model="ruleForm.remark" v-trim
                        maxlength="180"
                        :placeholder="`填写${typeName}的具体描述、备注等`"
                        show-word-limit
                        type="textarea"
                        :rows="5"
                        :autosize="false"
                        class="w-1156"
                    />
                </el-form-item>
            </div>
        </el-form>
        <div class="addbtn_box">
            <el-button
                color="#0071DC"
                class="submit"
                @click="submitForm(ruleFormRef)"
            >
                提交
            </el-button>
        </div>
    </div>
</template>
<script lang="ts">
import {
    reactive,
    toRefs,
    defineComponent,
    ref,
    getCurrentInstance,
    onMounted,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/store/User';
import orderApi from '@/api/PcModule/order';
import goodsApi from '@/api/PcModule/goods';
import { isName } from "@/utils/validate";
export default defineComponent({
    name: 'Service',
    setup() {
        const { proxy } = getCurrentInstance();
        let router = useRouter();
        let route = useRoute();
        const store = useUserStore();
        const data = reactive({
            fileList: [],
            fileName: '',
            typeName: route.query.type === 'DUE_TIME' ? '询交期' : '询价',
            detailsData: {},
        });
        
        const refData = toRefs(data);
        onMounted(() => {
            if (route.query.id) {
                getDetailsAction();
            }
            // 自动填充上次保存的信息
            if (localStorage.getItem('consultData')) {
                var sd = JSON.parse(localStorage.getItem('consultData'));
                ruleForm.requireQuantity = sd.requireQuantity;
                if (sd.requireTimeRange != 'NO_REQUIRE' && sd.requireTimeRange != 'ONE_WEEK_WITHIN' && sd.requireTimeRange != 'TWO_WEEK_WITHIN' && sd.requireTimeRange != 'ONE_MONTH_WITHIN') {
                    ruleForm.requireTimeRange = 'OTHER';
                    ruleForm.otherTime = sd.requireTimeRange;
                } else {
                    ruleForm.requireTimeRange = sd.requireTimeRange;
                }
                ruleForm.remark = sd.remark;
                ruleForm.contacts = sd.contacts;
                ruleForm.subjectType = sd.subjectType;
                if (sd.subjectType  == '1') {
                    ruleForm.companyName = sd.companyName;
                }
                localStorage.removeItem('consultData');
            }
        });
        const getDetailsAction = async () => {
            let data = await goodsApi.getDetails({
                spuId: route.query.id,
            });
            if (data.code == 200) {
                refData.detailsData.value = data.data || {};
            }
        };
        const ruleFormRef = ref<FormInstance>();
        let ruleForm = reactive({
            remark: '',
            requireQuantity: '',
            requireTimeRange: '',
            contacts: '',
            subjectType: '',
            companyName: '',
        });
        const rules = reactive({
            requireTimeRange: [
                {
                    required: true,
                    message: '请选择需求时间',
                    trigger: 'blur',
                },
            ],
            requireQuantity: [
                {
                    required: true,
                    message: '请填写需求数量',
                    trigger: 'blur',
                },
            ],
            contacts: [
                {
                    required: true,
                    validator: (rule: any, value: any, callback: any) => {
                        if (value != "") {
                            if (!isName(value)) {
                                callback(new Error("请输入正确的联系人"));
                            } else {
                                callback();
                            }
                        } else {
                            callback(new Error("请填写联系人"));
                        }
                    },
                    trigger: 'blur',
                },
            ],
            subjectType: [
                {
                    required: true,
                    message: '请选择主体类型',
                    trigger: 'change',
                },
            ],
        });
        // 确定
        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (ruleForm.subjectType === '1' && ruleForm.companyName == '') {
                        proxy.$msg.error('请输入公司名称');
                        return;
                    }
                    if (ruleForm.subjectType === '1' && !/^[\u4e00-\u9fa5]+$/.test(ruleForm.companyName)) {
                        proxy.$msg.error('公司名称只能包含汉字');
                        return;
                    }
                    let params = {};
                    params.consultType = route.query.type;
                    params.spuId = route.query.id;
                    params.requireQuantity = ruleForm.requireQuantity;
                    params.requireTimeRange = ruleForm.requireTimeRange;
                    params.remark = ruleForm.remark;
                    params.contacts = ruleForm.contacts;
                    params.subjectType = ruleForm.subjectType;
                    if (ruleForm.subjectType === '1') {
                        params.companyName = ruleForm.companyName;
                    }
                    if (ruleForm.requireTimeRange === 'OTHER') {
                        params.requireTimeRange = ruleForm.otherTime;
                    }

                    // 判断是否登录
                    if (store.userInfo.id) {
                        submitYes(params);
                    } else {
                        localStorage.setItem('consultData', JSON.stringify(params));
                        router.push({
                            name: 'login',
                            query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
                        });
                    }
                }
            });
        };
        const submitYes = async (params: object) => {
            let data = await orderApi.consultAdd(params);
            if (data.code == 200) {
                proxy.$msg.success('申请成功！');
                ruleForm.requireQuantity = '';
                ruleForm.requireTimeRange = '';
                ruleForm.remark = '';
                router.replace({
                    name: 'mineConsult',
                });
            }
        };
        const requireQuantityChange = (value: string) => {
            ruleForm.requireQuantity = value.replace(/[^0-9]/g,'');
        }
        return {
            ...refData,
            ruleFormRef,
            ruleForm,
            rules,
            submitForm,
            requireQuantityChange,
        };
    },
});
</script>
<style scoped lang="scss">
.home {
    background-color: #f4f8fe;
}

.technicalservice {
    width: $inner-width;
    margin: 20px auto 0;
    .technicalservice-img {
        width: 100%;
        height: 280px;
        border-radius: 2px;
        border-radius: 10px;
        margin-top: 20px;
    }

    .technicalservice_headbox {
        display: flex;
        width: 100%;
        height: 180px;
        background-color: #f7f8fa;
        border-radius: 6px;
        overflow: hidden;

        .technicalservice_headleft,
        .technicalservice_headright {
            img {
                width: 260px;
                height: 180px;
            }
        }

        .technicalservice_headleft {
            img {
                border-bottom-left-radius: 6px;
                border-top-left-radius: 6px;
            }
        }

        .technicalservice_headcenter {
            width: 680px;
            text-align: center;

            .center_top {
                font-size: 30px;
                color: #333;
                font-weight: 700;
                margin-bottom: 10px;
                margin-top: 53px;
            }

            .center_bottom {
                font-size: 16px;
                color: #333;
                font-weight: 400;
            }
        }
    }

    .technicalservice-title {
        width: 100%;
        text-align: center;
        font-size: 28px;
        color: #333333;
        font-weight: 700;
        margin-top: 60px;
        margin-bottom: 16px;
    }

    .title_tap {
        width: 100%;
        // text-align: center;
        font-size: 16px;
        color: #333;
        font-weight: 400;
    }

    .technicalservice-content {
        width: 1200px;
        border-radius: 4px;
        background: #f7f8fa;
        border-radius: 4px;
        padding-top: 0px;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 20px;
        box-sizing: border-box;

        .content-tips {
            margin-top: 166px;

            .content-tips-title {
                font-size: 16px;
                line-height: 22px;
                color: $font-color-weight-txt;
            }

            .content-tips-inner {
                .content-tips-inner-title {
                    font-size: 14px;
                    line-height: 20px;
                    color: $font-color-weight-txt;
                    margin-bottom: 8px;
                }

                .content-tips-inner-p {
                    font-size: 14px;
                    line-height: 220%;
                    color: #999999;
                }
            }
        }
    }

    .technicalservice-flow {
        // height: 178px;
        background: #ffffff;
        border-radius: 4px;
        padding: 48.86px 93px 40px 92px;
        display: flex;

        .flow_box {
            display: flex;

            .content_box {
                width: 120px;
                text-align: center;

                .icon_img {
                    img {
                        width: 28px;
                        height: 28px;
                    }
                }

                .contenrt_title {
                    font-size: 14px;
                    color: #333;
                    font-weight: 600;
                    margin-bottom: 11px;
                    margin-top: 12px;
                }

                .content_txt {
                    width: 120px;
                    height: 30px;
                    line-height: 30px;
                    background: #f1f9ff;
                    border-radius: 4px;
                    font-size: 12px;
                    color: #0071dc;
                }
            }

            .arrowhead_img {
                width: 32px;
                height: 32px;
                margin-left: 71px;
                margin-right: 72px;
                margin-top: 33px;
            }
        }
    }

    .submit {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 140px;
        height: 40px;
        background: $font-color;
        border: 1px solid $font-color;
        color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 30px;
        font-size: 14px;
        margin-bottom: 60px;
    }
}
</style>

<style lang="scss">
.el-popper.el-select__popper {
    z-index: 15 !important;
}
.technicalservice-form {
    width: 1200px;
    .goods-box {
        width: 100%;
        display: flex;
        margin-bottom: 30px;
        .goods-item {
            width: 33.3%;
            display: flex;
            padding: 10px 0 0 13px;
            box-sizing: border-box;
            p {
                color: #333;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
    .technicalservice-content {
        display: flex;
        flex-wrap: wrap;
        line-height: 10px;

        .title_tap {
            font-size: 14px;
            font-weight: 700;
            margin-top: 20px;
            margin-bottom: 10px;
            height: 17px;
            line-height: 17px;
        }

        .el-form-item {
            margin-left: 20px;
            margin-bottom: 30px;

            .el-form-item__label {
                text-align: right;
                line-height: 40px;
                font-size: 14px;
            }

            .w-370 {
                width: 491px;
                height: 40px;

                .el-input__wrapper {
                    background: #fff !important;
                    border-radius: 6px;
                    border: #fff;
                }

                .el-textarea__inner {
                    min-height: 80px !important;
                    max-height: 240px !important;
                    background: #fff !important;
                    border-radius: 6px;
                    --el-input-border-color: #fff;
                }

                .prepend_box {
                    background-color: #fff;
                    box-shadow: none;
                    padding-left: 10px;
                    padding-right: 0;
                    border-bottom-left-radius: 6px;
                    border-bottom-left-radius: 6px;
                }
            }
            .w-1156 {
                width: 1156px;
            }
            .budget_input {
                position: relative;

                .prepend_box {
                    position: absolute;
                    top: 4px;
                    left: 10px;
                    font-size: 14px;
                    font-weight: 400;
                }
            }

            .m-2 {
                width: 150px;
                margin-right: 10px;
                .el-input__wrapper {
                    width: 150px;
                    height: 36px;
                    border-radius: 6px;
                    border: #fff;
                }
            }

            .el-select {
                .el-input .el-select__caret {
                    //箭头样式
                    background: url(../../assets/images/ProHome/packup.svg)
                        no-repeat; //自定义图片
                    appearance: none;
                    background-size: 11.5px 11.5px;
                    width: 11.5px;
                    height: 11.5px;
                    position: absolute !important; //图片定位
                    top: 13px;
                    right: 10px;
                }

                .el-icon svg {
                    //隐藏原来箭头
                    display: none;
                }
            }
        }
    }

    .technicalservice-content-2 {
        padding-top: 20px !important;
        .el-form-item {
            margin-left: 0 !important;
        }
        .w-370-1 {
            width: 428px !important;
        }

        .w-370-2 {
            width: 422px !important;
            .el-input__wrapper {
                padding-left: 24px;
            }
        }

        .w-370-3 {
            width: 310px !important;
        }

        .contactsgp {
            width: 478px;
            height: 40px;
        }

        .describes_item {
            width: 1160px;
            position: relative;
            .el-form-item__content {
                margin-left: 0 !important;
            }

            .w-370 {
                width: 1160px;
                height: auto;
                min-height: 100px;

                .el-input__count {
                    background: #fff !important;
                    color: #333;
                }
            }
        }
    }

    .checkbox {
        margin: 20px 0;
    }
}
.subjectType {
    padding-left: 50px;
}
.date-item {
    padding-left: 50px;
    .el-form-item__content {
        height: 40px !important;
        // width: 160px !important;
        // margin-left: 10px;
    }

    .select {
        width: 160px !important;
        height: 40px;
        margin-right: 10px;

        .el-input__wrapper {
            .el-input__inner {
                width: 130px !important;
                height: 38px;
                border-radius: 6px;
                border: #fff;
            }
        }
    }
}
.technicalservice-content {
    .el-form-item__label-wrap {
        margin-right: 0 !important;
    }
}
.hdsitem {
    span {
        font-size: 14px;
    }
}
.technicalservice {
    .el-select__placeholder {
        span {
            font-size: 14px;
        }
    }
}
</style>
